import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import { TextField } from '@mui/material';

interface Props {
  label: string;
  type: string;
  width?: string;
  disabled?: boolean;
  size?: any;
  value?: string;
  error?: boolean;
  helperText?: string;
  onChange?: (e: any) => void;
}

const CssTextField = styled(TextField)({
  '& .MuiInputBase-input.Mui-disabled': {
    WebkitTextFillColor: 'var(--app-text-primary)',
  },
  '& .MuiFormLabel-root.Mui-disabled': {
    color: 'var(--app-text-secondary)',
  },
});

export const MyDateTextField: FunctionComponent<Props> = ({
  label,
  type,
  width,
  disabled,
  size,
  value,
  error,
  helperText,
  onChange,
}) => {
  const { t } = useTranslation();
  return (
    <CssTextField
      label={label}
      value={value}
      variant="filled"
      type={type}
      onChange={onChange}
      error={error && value === ''}
      disabled={disabled}
      style={{
        width,
        fontFamily: 'sans-serif',
      }}
      helperText={error && value === '' ? t('enterValue') : helperText}
      size={size}
      InputLabelProps={{
        shrink: true,
      }}
    />
  );
};

MyDateTextField.defaultProps = {
  value: '',
  width: '100%',
  size: 'large',
  disabled: false,
  error: false,
  helperText: '',
  onChange: undefined,
};
